import { useMemo } from 'react';

import { PatientMedicine, PrescriptionHistoryDailyGroup } from '@dreryk/egabinet-prescription-frontend-api';

import { TableDataAccessor } from '@dreryk/react-components';

import { MedicineSafetyIndicatorsConfigResolver } from '~libs.shared.medicine';

import { isSelectablePrescription } from './PatientPrescriptionHistoryTable.utils';

export const PatientPrescriptionHistoryTableDataAccessor: TableDataAccessor<PrescriptionHistoryDailyGroup> = (
   props
) => {
   const medicines = useMemo<PatientMedicine[]>(
      () =>
         props.currentPage.flatMap((prescriptionDailyGroup) =>
            prescriptionDailyGroup.prescriptions.flatMap((prescription) =>
               prescription.medicine && isSelectablePrescription(prescription)
                  ? [
                       {
                          medicine: prescription.medicine,
                          reimbursements: [],
                          patientContinuouslyUsedMedicineId: prescription.patientContinuouslyUsedMedicineId,
                       },
                    ]
                  : []
            )
         ),
      [props.currentPage]
   );

   return <MedicineSafetyIndicatorsConfigResolver medicines={medicines} />;
};
